import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import WhatsAppButton from './WhatsAppButton';
import WhatsAppShareButton from './WhatsAppShareButton';
import {
  formatDate,
  formatToAmPm,
  LEAD_STATUS_COLORS,
} from '../../constants/DateFormatter';
import { toast } from 'react-toastify';
//import WhatsAppShareButton from './WhatsAppShareButton';
// import {
//   confirmDialog,
//   showError,
//   showSuccess,
//   showWarning,
// } from '../../../utils/alertService';
const Leadhistory = () => {
  const location = useLocation();
  const { leadId } = useParams();
  const [originalAssigneeId, setOriginalAssigneeId] = useState(0);

  //const [leadId, setLeadId] = useState([]);
  const [showTaskModal, setShowTaskModal] = useState(false); // State for modal visibility
  const [errorMessage, setErrorMessage] = useState({});
  const [txtMessage, setTxtMessage] = useState('');
  const [userMaster, setuserMaster] = useState([]);
  const navigate = useNavigate();
  const [selectedStaff, setSelectedStaff] = useState('');
  //   const [showRemarkFields, setShowRemarkFields] = useState(false);
  //   const [showTaskModal, setShowTaskModal] = useState(false); // For showing/hiding the main modal
  const [showEmailFields, setShowEmailFields] = useState(false); // For Email fields
  const [showWhatsAppFields, setShowWhatsAppFields] = useState(false); // For WhatsApp fields
  const [showRemarkFields, setShowRemarkFields] = useState(false); // For Remark fields
  const [showTransfer, setShowTransfer] = useState(false); // For Remark fields
  const [leadhistory, setleadhistory] = useState([]);
  const [leadMasterData, setLeadMasterData] = useState({
    id: 0,
    lead_id: '',
    uniq_id: '',
    lead_date: new Date().toISOString().split('T')[0],
    lead_date_import: new Date().toISOString().split('T')[0],
    lead_status: '',
    lead_type: '',
    lead_type_detail: '',
    lead_rating: '',
    lead_source: '',
    lead_remark: '',
    sr_no_of_import_file: 0,
    cust_name: '',
    company_name: '',
    no_of_employee: '',
    turnover_detail: 0,
    designation_detail: '',
    cust_mobile: '',
    cust_email: '',
    cust_website: '',
    address_line1: '',
    location_detail: '',
    area_detail: '',
    city_name: '',
    state_name: '',
    country_name: '',
    pin_code: '',
    rec_updated_yn: '',
    lead_belong_to: '',
    lead_belong_to_id: 0,
    lead_import_by_user: '',
    lead_import_by_user_id: 0,
    cust_id: 0,
    follow_date: new Date().toISOString().split('T')[0],
    followup_time: '12:00',
    followup_time1: '12:00',
    status: '',
  });

  const initalStatus = {
    lead_id: 0,
    lead_status: '',
    lead_status_id: 0,
    follow_date: new Date().toISOString().split('T')[0], // "YYYY-MM-DD"
    followup_time: new Date().toTimeString().slice(0, 5), // "HH:mm"
    lead_remark: '',
  };
  const [leadStatusHistory, setLeadStatusHistory] = useState(initalStatus);
  const [leadCustomer, setLeadCustomer] = useState([]);
  const toggle = () => setmodal(!modal);
  const [LeadStatusList, setLeadStatusList] = useState([]);
  const [MPTMasterData, setMPTMasterData] = useState({
    multi_purpose_flag: '',
    multi_purpose_code: '',
    multi_purpose_type: '',
    multi_purpose_remark: '',
  });
  const [sendEmailData, setSendEmailData] = useState({
    to: '',
    cc: '',
    subject: '',
    body: '',
  });

  const onChangeHandleEmail = (e) => {
    const { name, value } = e.target;
    setSendEmailData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEmailSubmit = async () => {
    try {
      debugger;

      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const formattedData = {
        ...leadMasterData,
        description: sendEmailData.body,
        subject: sendEmailData.subject,
        cust_email: sendEmailData.to,
      };
      debugger;
      const data1 = JSON.stringify(formattedData);

      const response = await apiService.post(
        `api/Lead_Master_Import/SendEmail`,
        data1,
        config
      );

      if (response.status === true) {
        //showSuccess(response.message, '');
        //alert(response.message);
      } else {
        alert(response.message);
      }
      //navigate('/Dashboard/searchleadmaster');
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  const onChangeHandle1 = (e) => {
    const { name, value } = e.target;
    setMPTMasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [dynamicmultipurpose, setdynamicmultipurpose] = useState(false);
  const [dynamiclable, setdynamiclable] = useState(false);
  const [modal, setmodal] = useState(false);
  const [StatusList, setStatusList] = useState([]);

  const Getleadbyid = async (id) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/Lead_Master_Import/GetLead_Master_Import_ById?id=${id}`,
        config
      );
      if (response.status === true) {
        debugger;
        // setAssineName(response.assigneName);
        const leadData = response.lead;
        const leadCustomer = response.customer;
        setLeadCustomer(leadCustomer);
        setOriginalAssigneeId(leadData.lead_belong_to_id);
        // Convert the follow_date to yyyy-mm-dd format
        const followDate = new Date(leadData.follow_date);
        const formattedDate = `${followDate.getFullYear()}-${String(
          followDate.getMonth() + 1
        ).padStart(2, '0')}-${String(followDate.getDate()).padStart(2, '0')}`;

        leadData.follow_date = formattedDate;

        // Convert followup_time to HH:mm format
        // const followupTime = new Date(leadData.followup_time);
        // const formattedTime = `${String(followupTime.getHours()).padStart(
        //   2,
        //   '0'
        // )}:${String(followupTime.getMinutes()).padStart(2, '0')}`;

        // leadData.followup_time = formattedTime;

        setLeadMasterData(leadData); // Set lead data with formatted date and time
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error(error);
      alert('Something went wrong!');
    }
  };

  const GetCustomerHistory = async (leadIdState) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        // `api/Lead_Master_Import/GetLeadHistoryByLeadId?leadId=${leadId}`,
        `api/Lead_Master_Import/GetLeadHistoryByLeadId?leadId=${leadIdState}`,

        config
      );
      console.log(response, 'history');
      setleadhistory(response); // Set lead data
    } catch (error) {
      console.error(error);
      alert('Something went wrong!');
    }
  };
  const onHandleMultipleValue = (param) => {
    debugger;
    setmodal(!modal);
    setMPTMasterData((prevData) => ({
      ...prevData,
      multi_purpose_flag: param,
    }));
  };
  // Assuming you're displaying the history data in a table or list
  const MPTMaster_Add_Edit_Screen = async () => {
    try {
      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = JSON.stringify(MPTMasterData);

      let response;

      if (MPTMasterData.id === '0' || MPTMasterData.id === 0) {
        response = await apiService.put(
          `api/Multi_Purpose_Type_Master/UpdateMulti_Purpose_Type_Master?id=${MPTMasterData.id}`,
          data,
          config
        );
      } else {
        response = await apiService.post(
          'api/Multi_Purpose_Type_Master/AddMulti_Purpose_Type_Master',
          data,
          config
        );
      }
      debugger;
      if (response.status === true) {
        //showSuccess(response.message, '');
        // alert(response.message);
        //resetMPTMasterData();
        setmodal(!modal);
        //Get_All_MPT_Master();
        getMulti_Purpose_Type_MasterData();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong"');
    }
  };

  const convertAdmission = async () => {
    try {
      let response = await apiService.get(
        `api/Lead_Master_Import/ConvertLeadToAdmission?leadId=${leadMasterData.id}`
      );

      if (response.status === true) {
        toast.success(response.message);
        setLeadMasterData(response.lead);
        //pending enrollment function
        // navigate('/pending-enrollment-list');
        //toast.success("Now Proceed with enrollment");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong"');
    }
  };

  const handleButtonClick = (field) => {
    // Reset all fields
    setShowEmailFields(false);
    setShowWhatsAppFields(false);
    setShowRemarkFields(false);

    // Show only the selected field
    if (field === 'email') setShowEmailFields(true);
    if (field === 'whatsapp') setShowWhatsAppFields(true);
    if (field === 'remark') {
      setShowRemarkFields(true);
      setLeadStatusHistory(initalStatus);
    }
  };
  const GetUserMaster = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };
      debugger;
      const response = await apiService.get(
        `api/User_Detail/GetAllUserMaster`,
        config
      );
      debugger;
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors);
      }
      setuserMaster(response.user_Detail_List);
    } catch (error) {
      console.log(error);
      alert('SomeThing went wrong!!');
    }
  };

  const onHandleEdit = () => {
    debugger;
    navigate('/new-lead', {
      state: {
        rowdat: { ...leadMasterData },
        leadCustomer: { ...leadCustomer },
      },
    });
  };

  const getMulti_Purpose_Type_MasterData = async () => {
    try {
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=lead_status&orderBy=id`
      );

      if (response.status === true) {
        const LeadStatusList = response.data;
        setLeadStatusList(LeadStatusList);
      } else {
        alert(response.message);
      }

      const response2 = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=status`
      );

      if (response2.status === true) {
        const LeadStatusList = response2.data;
        setStatusList(LeadStatusList);
        //const map = generateStatusColorMap(LeadStatusList);
        //setStatusColorMap(map);
      } else {
        alert(response2.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  const updateLeadData = async (customData, validate = false, mode = '') => {
    try {
      // ✅ Step 1: Conditional Validation
      if (validate) {
        if (mode === 'transfer') {
          if (!leadMasterData.lead_belong_to_id) {
            toast.error('Please select a staff member.');
            return;
          }

          if (leadMasterData.lead_belong_to_id === originalAssigneeId) {
            toast.error(
              'Please select a different staff member to transfer the lead.'
            );
            return;
          }
        }

        if (mode === 'status') {
          if (
            !leadStatusHistory.follow_date ||
            !leadStatusHistory.followup_time ||
            !leadStatusHistory.lead_status
            //!leadStatusHistory.lead_remark
          ) {
            toast.error('Please fill all required fields before saving.');
            return;
          }
        }
      }
      const leadStatusData = {
        lead_id: leadMasterData.id,
        follow_date: leadStatusHistory.follow_date,
        followup_time: leadStatusHistory.followup_time,
        lead_status: leadStatusHistory.lead_status,
        lead_status_id: leadStatusHistory.lead_status_id,
        status: leadStatusHistory.status,
        lead_remark: leadStatusHistory.lead_remark,
        lead_belong_to: leadMasterData.lead_belong_to,
        lead_belong_to_id: leadMasterData.lead_belong_to_id,
        ...customData, // override any fields if passed
      };
      console.log(leadStatusData);
      const response = await apiService.put(
        `api/Lead_Master_Import/AddLeadStatusHistory`,
        leadStatusData
      );

      console.log(response);
      toast.success(response.message);

      // Update state
      setLeadMasterData(response.lead);

      // Refresh history if needed
      GetCustomerHistory(leadMasterData.id);

      // Close modals
      setShowTaskModal(false);
      setShowTransfer(false);

      // navigate('/lead-history');
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  const getUserData = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/admin/User_Detail/GetUsers?vendorId=${leadMasterData.vendor_id}&branchId=${leadMasterData.branch_id}&filter=operator`,
        config
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setuserMaster(response.user_DetailData);
        //setUserTable(response.user_DetailData)
        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    getMulti_Purpose_Type_MasterData();
    getUserData();
  }, [leadMasterData]);

  useEffect(() => {
    Getleadbyid(leadId); // Fetch lead details by ID
    GetCustomerHistory(leadId);
  }, []); // Run only once on component mount

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    setLeadMasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onChangeHandleMsg = (e) => {
    const { value } = e.target;
    setTxtMessage(value); // Directly update the string value
  };

  const [formData, setFormData] = useState({
    to: 'amairakha@gmail.com',
    subject: '',
    description: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // const onChangeRemarkHandle = (e) => {
  //   const { name, value } = e.target;
  //   setLeadMasterData((prevData) => ({ ...prevData, [name]: value }));
  //   // const { name, value } = e.target;
  //   // console.log("Field Name:", name);  // ✅ Check which field is updating
  //   // console.log("New Value:", value);  // ✅ Check the new value

  //   // setLeadMasterData((prevData) => ({ ...prevData, [name]: value }));
  // };
  const onChangeRemarkHandle = (e) => {
    const { name, value } = e.target;

    if (name === 'lead_status_id') {
      // Get the label (text) of the selected option
      const label = e.target.options[e.target.selectedIndex].text;

      setLeadStatusHistory((prevData) => ({
        ...prevData,
        lead_status: label, // save the label as readable text
        [name]: value, // save the ID or value
      }));
    } else {
      setLeadStatusHistory((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      debugger;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      };
      // const response = await apiService.get(
      //   `api/Lead_Master_Import/SendEmail`;
      //   config
      // });
      // Base URL with query parameters for the GET request
      //const baseUrl = `api/Lead_Master_Import/SendEmail`;
      // const queryParams = new URLSearchParams({
      //   toEmail: leadMasterData.cust_email,
      //   subject: formData.subject,
      //   body: formData.descriptio,
      // });
      const formattedData = {
        ...leadMasterData,
        description: formData.description,
        subject: formData.subject,
      };
      debugger;
      const data1 = JSON.stringify(formattedData);

      const response = await apiService.post(
        `api/Lead_Master_Import/SendEmail`,
        config,
        data1
      );
      debugger;

      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors);
      }

      if (response.status === true) {
        //showSuccess(response.message, '');
        // alert('Email sent successfully!');
        setShowTaskModal(false);
      } else {
        alert(response.message || 'Failed to send email.');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('An error occurred while sending the email.');
    }
  };

  return (
    <div className='card shadow-sm border-0 mb-4'>
      <div className='card-body'>
        {/* Header Section */}
        <div className='p-3 rounded bg-light border shadow-sm mb-4'>
          {/* Top Row: Title + Status */}
          <div className='d-flex flex-wrap justify-content-between align-items-center mb-2'>
            <div>
              <h5 className='text-primary mb-1 fw-semibold'>
                <i className='bi bi-info-circle mr-2'></i>Lead Overview
              </h5>
              <div className='text-muted small'>
                <span className='mr-3'>
                  <i className='bi bi-hash mr-2'></i>
                  Lead ID:{' '}
                  <span className='fw-semibold text-dark'>
                    {leadMasterData.id || 'N/A'}
                  </span>
                </span>
                <span>
                  <i className='bi bi-calendar-event mr-2'></i>
                  Created On:{' '}
                  <span className='fw-semibold text-dark'>
                    {formatDate(leadMasterData.lead_date) || 'N/A'}
                  </span>
                </span>
              </div>
            </div>

            {/* Optional: Status Badge */}
            <div className='mt-2 mt-md-0 fw-bold'>
              Current status :
              <span
                className={`badge rounded-pill px-3 py-2 ml-2 ${
                  LEAD_STATUS_COLORS[leadMasterData.lead_status] ||
                  'bg-light text-dark'
                }`}
              >
                {leadMasterData.lead_status || 'N/A'}
              </span>
            </div>
          </div>

          {/* Bottom Row: Action Buttons */}
          <div className='d-flex flex-wrap gap-2 mt-3 justify-content-end'>
            {/* <button
              className="btn btn-sm btn-primary flex-grow-1 flex-md-grow-0"
              onClick={() => {
                handleButtonClick("email");
                setShowTaskModal(true);
              }}
            >
              <i className="bi bi-envelope mr-2"></i>Email
            </button> */}

            <button
              className='mr-2 btn btn-sm btn-success flex-grow-1 flex-md-grow-0'
              onClick={() => {
                handleButtonClick('whatsapp');
                setShowTaskModal(true);
              }}
            >
              <i className='bi bi-whatsapp mr-1'></i>WhatsApp
            </button>

            {/* Edit & Navigation */}
            <button
              className='mr-2 btn btn-sm btn-info flex-grow-1 flex-md-grow-0'
              onClick={onHandleEdit}
            >
              <i className='bi bi-pencil-square mr-1'></i>Edit
            </button>

            <button
              className='mr-2 btn btn-sm btn-danger flex-grow-1 flex-md-grow-0'
              onClick={() => setShowTransfer(true)}
            >
              <i className='bi bi-arrow-left-right mr-1'></i>Transfer
            </button>

            <button
              className='mr-2 btn btn-sm btn-warning flex-grow-1 flex-md-grow-0'
              onClick={() => {
                handleButtonClick('remark');
                setShowTaskModal(true);
              }}
            >
              <i className='bi bi-pencil mr-1'></i>Update Status
            </button>

            {leadMasterData.lead_status === 'Admission Confirmed' &&
              leadMasterData.converted_adm_yn === 'no' && (
                <button
                  className='mr-2 btn btn-sm btn-primary flex-grow-1 flex-md-grow-0'
                  onClick={convertAdmission}
                >
                  <i className='bi bi-mortarboard mr-1'></i>Convert into
                  Admission
                </button>
              )}
            <button
              className='mr-2 btn btn-sm btn-secondary flex-grow-1 flex-md-grow-0'
              onClick={() => navigate('/all-leads')}
            >
              <i className='bi bi-arrow-left mr-1'></i>Back
            </button>
          </div>
        </div>

        <div className='row g-3 mb-3'>
          {/* Left Column - Customer Profile */}

          <div className='col-md-4'>
            <div className='card h-100 shadow-sm border'>
              {/* ✅ Card Header */}
              <div className='card-header bg-light fw-semibold text-primary d-flex align-items-center'>
                <i className='bi bi-person-lines-fill mr-2'></i>
                Customer Details
              </div>

              <div className='card-body text-center'>
                <div className='mb-3'>
                  <h3>
                    <i className='bi bi-person-circle'></i>
                  </h3>
                </div>

                <h6 className='fw-bold mb-0'>
                  {leadMasterData.cust_name || 'N/A'}
                </h6>
                <small className='text-muted'>
                  {leadMasterData.cust_email || 'N/A'}
                </small>

                <div className='mt-2 text-muted small'>
                  <i className='bi bi-telephone mr-2'></i>{' '}
                  {leadMasterData.cust_mobile || 'N/A'}
                  <br />
                  <i className='bi bi-whatsapp mr-2'></i>{' '}
                  {leadMasterData.cust_wp_mobile || leadMasterData.cust_mobile}
                </div>

                <div className='mt-3 text-start border-top pt-3'>
                  <div className='mb-2'>
                    <span className='text-muted small'>Address:</span>
                    <div className='fw-semibold text-truncate'>
                      {leadMasterData.address_line1 || 'N/A'}
                    </div>
                  </div>

                  {/* ✅ City, State, Country in one line */}
                  <div className='mb-0'>
                    <span className='text-muted small'>Location:</span>
                    <div className='fw-semibold text-truncate'>
                      {leadMasterData.city_name + ', ' || ''}
                      {leadMasterData.state_name + ', ' || ''}
                      {leadMasterData.country_name || ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Lead Details */}
          <div className='col-md-8'>
            <div className='card h-100 shadow-sm border'>
              <div className='card-header bg-light fw-semibold text-primary d-flex justify-content-between align-items-center'>
                <span>
                  <i className='bi bi-pencil-square mr-2'></i>Lead Details
                </span>
                <span
                  className={`badge rounded-pill px-3 py-2 ${
                    LEAD_STATUS_COLORS[leadMasterData.lead_status] ||
                    'bg-light text-dark'
                  }`}
                >
                  {leadMasterData.lead_status || 'N/A'}
                </span>
                {/* <span
                  className={`badge rounded-pill px-3 py-2 ${getStatusBadgeClass(
                    leadMasterData.lead_status
                  )}`}
                >
                  {leadMasterData.lead_status || "N/A"}
                </span> */}
              </div>

              <div className='card-body'>
                <div className='row g-3'>
                  <div className='col-sm-6 mb-3'>
                    <div className='text-muted fw-bold'>Assigned To</div>
                    <div>{leadMasterData.lead_belong_to || 'N/A'}</div>
                  </div>

                  <div className='col-sm-6 mb-3'>
                    <div className='text-muted fw-bold'>Product</div>
                    <div>{leadMasterData.product || 'N/A'}</div>
                  </div>

                  <div className='col-sm-6 mb-3'>
                    <div className='text-muted fw-bold'>Follow-up Date</div>
                    <div>{formatDate(leadMasterData.follow_date) || 'N/A'}</div>
                  </div>

                  <div className='col-sm-6 mb-3'>
                    <div className='text-muted fw-bold'>Follow-up Time</div>
                    <div>
                      {formatToAmPm(leadMasterData.followup_time) || 'N/A'}
                    </div>
                  </div>

                  <div className='col-sm-6 mb-3'>
                    <div className='text-muted fw-bold'>Source</div>
                    <div>{leadMasterData.lead_source || 'N/A'}</div>
                  </div>
                  <div className='col-sm-6 mb-3'>
                    <div className='text-muted fw-bold'>Acquired On</div>
                    <div>{formatDate(leadMasterData.lead_date) || 'N/A'}</div>
                  </div>

                  <div className='col-sm-12'>
                    <div className='text-muted fw-bold'>Other Remarks</div>
                    <div>{leadMasterData.lead_remark || 'N/A'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* History Section */}
        {leadhistory.length > 0 && (
          <div className='card shadow-sm'>
            <div className='card-header bg-light fw-semibold text-primary'>
              <i className='bi bi-clock-history mr-2'></i> History
            </div>
            <div className='table-responsive'>
              <table className='table table-striped table-hover align-middle mb-0'>
                <thead className='table-light'>
                  <tr>
                    <th>#</th>
                    <th className='text-center'>Lead Status</th>
                    <th>Assigned To</th>
                    {/* <th>Action</th> */}
                    <th>Follow-up Date</th>
                    <th>Follow-up Time</th>
                    {/* <th>Conversation Remark</th> */}
                    <th className='text-center'>Other Remark</th>
                    <th>Changed on</th>
                  </tr>
                </thead>
                <tbody>
                  {leadhistory.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td className='text-center'>
                        <span
                          className={`badge rounded-pill px-3 py-2 ${
                            LEAD_STATUS_COLORS[item.lead_status] ||
                            'bg-light text-dark'
                          }`}
                        >
                          {item.lead_status || 'N/A'}
                        </span>
                      </td>
                      <td>{item.lead_belong_to || '–'}</td>
                      {/* <td>{item.status}</td> */}

                      <td>
                        {item.follow_date ? formatDate(item.follow_date) : '–'}
                      </td>
                      <td>
                        {item.followup_time
                          ? formatToAmPm(item.followup_time)
                          : '–'}
                      </td>
                      <td className='text-center'>{item.lead_remark || '–'}</td>
                      <td>
                        {item.history_date_time
                          ? formatDate(item.history_date_time)
                          : '–'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Add Task Button */}

      {showTaskModal && (
        <>
          {/* Backdrop */}
          <div className='modal-backdrop fade show'></div>

          {/* Modal */}
          <div
            className='modal fade show'
            tabIndex='-1'
            role='dialog'
            style={{ display: 'block' }}
          >
            <div
              className='modal-dialog modal-lg modal-dialog-centered'
              role='document'
            >
              <div className='modal-content border-0 shadow-lg'>
                <div className='modal-header'>
                  <h5 className='modal-title'>
                    {showRemarkFields && 'Change Status'}
                    {showEmailFields && 'Compose Message'}
                    {showWhatsAppFields && 'WhatsApp'}
                  </h5>
                  <button
                    type='button'
                    className='btn-close btn-close-white'
                    onClick={() => setShowTaskModal(false)}
                    aria-label='Close'
                  ></button>
                </div>

                <div className='modal-body'>
                  {/* --- Email Fields --- */}
                  {showEmailFields && (
                    <form>
                      <div className='mb-3 row'>
                        <label className='col-sm-2 col-form-label'>To:</label>
                        <div className='col-sm-10'>
                          <input
                            type='email'
                            className='form-control'
                            name='to'
                            value={sendEmailData.to}
                            onChange={onChangeHandleEmail}
                          />
                        </div>
                      </div>

                      <div className='mb-3 row'>
                        <label className='col-sm-2 col-form-label'>Cc:</label>
                        <div className='col-sm-10'>
                          <input
                            type='text'
                            className='form-control'
                            name='cc'
                            value={sendEmailData.cc}
                            onChange={onChangeHandleEmail}
                          />
                        </div>
                      </div>

                      <div className='mb-3 row'>
                        <label className='col-sm-2 col-form-label'>
                          Subject:
                        </label>
                        <div className='col-sm-10'>
                          <input
                            type='text'
                            className='form-control'
                            name='subject'
                            value={sendEmailData.subject}
                            onChange={onChangeHandleEmail}
                          />
                        </div>
                      </div>

                      <div className='mb-3 row'>
                        <label className='col-sm-2 col-form-label'>
                          Message:
                        </label>
                        <div className='col-sm-10'>
                          <textarea
                            className='form-control'
                            rows='5'
                            name='body'
                            value={sendEmailData.body}
                            onChange={onChangeHandleEmail}
                          ></textarea>
                        </div>
                      </div>

                      <div className='text-right'>
                        <button
                          type='button'
                          className='btn btn-primary mr-2'
                          onClick={handleEmailSubmit}
                        >
                          <i className='bi bi-send'></i> Send
                        </button>
                        <button
                          type='button'
                          className='btn btn-secondary'
                          onClick={() => setShowTaskModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </form>
                  )}

                  {/* --- WhatsApp Fields --- */}
                  {showWhatsAppFields && (
                    <div>
                      <div className='mb-3'>
                        <label>
                          <strong>Mobile No</strong>
                        </label>
                        <input
                          type='text'
                          name='cust_mobile'
                          className='form-control'
                          value={leadMasterData.cust_mobile}
                          onChange={onChangeHandle}
                        />
                      </div>

                      <div className='mb-3'>
                        <label>
                          <strong>Message</strong>
                        </label>
                        <input
                          type='text'
                          name='txtMessage'
                          className='form-control'
                          value={txtMessage}
                          onChange={onChangeHandleMsg}
                        />
                      </div>

                      <div className='d-flex justify-content-end'>
                        <WhatsAppButton
                          className='btn btn-success mr-2'
                          phoneNumber={leadMasterData.cust_mobile}
                          message={txtMessage}
                          fileUrl=''
                          leadid={leadId}
                          cust_id={leadMasterData.cust_id}
                        />
                        <button
                          className='btn btn-secondary'
                          onClick={() => setShowTaskModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  )}

                  {/* --- Remark Fields --- */}
                  {showRemarkFields && (
                    <>
                      <div className='row g-3'>
                        {/* Lead Status */}
                        <div className='col-md-12'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <label className='form-label fw-bold mb-0'>
                              New Status (Current Status:{' '}
                              {leadMasterData.lead_status} ){' '}
                              <span className='text-danger'>*</span>
                            </label>
                            <button
                              className='btn btn-sm btn-primary'
                              onClick={() =>
                                onHandleMultipleValue(
                                  'lead_status_id',
                                  setdynamicmultipurpose('Add Lead Status'),
                                  setdynamiclable('Lead Status Name')
                                )
                              }
                            >
                              +
                            </button>
                          </div>
                          <select
                            className='custom-select mt-1'
                            name='lead_status_id'
                            value={leadStatusHistory.lead_status_id}
                            onChange={onChangeRemarkHandle}
                          >
                            <option value='0'>Select Lead Status</option>
                            {LeadStatusList?.map((option, index) => (
                              <option key={index} value={option.id}>
                                {option.multi_purpose_type}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Follow-up Date */}
                        <div className='col-md-6'>
                          <label className='form-label fw-bold'>
                            Follow-up Date{' '}
                            <span className='text-danger'>*</span>
                          </label>
                          <input
                            type='date'
                            className='form-control'
                            name='follow_date'
                            value={leadStatusHistory.follow_date}
                            min={new Date().toISOString().split('T')[0]}
                            onChange={onChangeRemarkHandle}
                          />
                          {errorMessage.follow_date && (
                            <small className='text-danger'>
                              {errorMessage.follow_date}
                            </small>
                          )}
                        </div>

                        {/* Follow-up Time */}
                        <div className='col-md-6'>
                          <label className='form-label fw-bold'>
                            Follow-up Time<span className='text-danger'>*</span>
                          </label>
                          <input
                            type='time'
                            className='form-control'
                            name='followup_time'
                            value={leadStatusHistory.followup_time}
                            onChange={onChangeRemarkHandle}
                          />
                          {errorMessage.followup_time && (
                            <small className='text-danger'>
                              {errorMessage.followup_time}
                            </small>
                          )}
                        </div>

                        {/* Conversation Remark */}
                        {/* <div className="col-md-6">
              <div className="d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold mb-0">Conversation Remark</label>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() =>
                    onHandleMultipleValue(
                      'status',
                      setdynamicmultipurpose('Add Status'),
                      setdynamiclable('Status Name')
                    )
                  }
                >
                  +
                </button>
              </div>
              <select
                className="custom-select mt-1"
                name="status"
                value={leadStatusHistory.status}
                onChange={onChangeRemarkHandle}
              >
                <option value="0">Select Conversation Remark</option>
                {StatusList?.map((option, index) => (
                  <option key={index} value={option.multi_purpose_type}>
                    {option.multi_purpose_type}
                  </option>
                ))}
              </select>
            </div> */}

                        {/* Remark */}
                        <div className='col-12'>
                          <label className='form-label fw-bold'>Remark</label>
                          <input
                            type='text'
                            className='form-control'
                            name='lead_remark'
                            value={leadStatusHistory.lead_remark}
                            onChange={onChangeRemarkHandle}
                          />
                        </div>
                      </div>

                      <div className='modal-footer'>
                        <button
                          type='button'
                          className='btn btn-primary'
                          onClick={() =>
                            updateLeadData(
                              { status: 'Status Updated' },
                              true,
                              'status'
                            )
                          }
                        >
                          Save Changes
                        </button>
                        <button
                          type='button'
                          className='btn btn-secondary'
                          onClick={() => setShowTaskModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ====================== Transfer Lead Modal ====================== */}
      {showTransfer && (
        <>
          <div className='modal-backdrop fade show'></div>

          <div
            className='modal fade show'
            style={{ display: 'block' }}
            tabIndex='-1'
            role='dialog'
          >
            <div className='modal-dialog' role='document'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title'>Transfer Lead</h5>
                  <button
                    type='button'
                    className='btn-close btn-close-white'
                    onClick={() => setShowTransfer(false)}
                  ></button>
                </div>

                <div className='modal-body'>
                  <label
                    htmlFor='lead_belong_to_id'
                    className='form-label fw-bold d-block mb-2'
                  >
                    Assign Lead To
                    <small className='text-right text-muted ml-2'>
                      (Currently:{' '}
                      {leadMasterData?.lead_belong_to?.toUpperCase() ||
                        'Unassigned'}
                      )
                    </small>
                  </label>
                  <select
                    id='lead_belong_to_id'
                    name='lead_belong_to_id'
                    // value={}
                    className='custom-select'
                    onChange={onChangeHandle}
                  >
                    <option value=''>— Select Operator —</option>
                    {userMaster?.map((user) => (
                      <option key={user.id} value={user.id}>
                        {`${user.user_name}  -  ${user.user_mobile} `}
                        {/* {`${user.user_name}  |  ${user.user_mobile}  |  ${user.user_email}`} */}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() =>
                      updateLeadData(
                        { status: 'Assignee Changed' },
                        true,
                        'transfer'
                      )
                    }
                  >
                    Save Changes
                  </button>
                  <button
                    type='button'
                    className='btn btn-secondary'
                    onClick={() => setShowTransfer(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {modal && (
        <div
          className='modal fade show'
          tabIndex='-1'
          role='dialog'
          style={{ display: 'block' }}
        >
          <div className='modal-dialog' role='document'>
            <div className='modal-content'>
              {/* Header */}
              <div className='modal-header bg-primary text-white'>
                <h5 className='modal-title'>{dynamicmultipurpose}</h5>
                <button
                  type='button'
                  className='btn-close btn-close-white'
                  onClick={toggle}
                  aria-label='Close'
                ></button>
              </div>

              {/* Body */}
              <div className='modal-body'>
                <div
                  className='accordion accordion-flush'
                  id='accordionFlushExample'
                >
                  <div className='form-group mb-3'>
                    <label htmlFor='multi_purpose_type' className='form-label'>
                      {dynamiclable}
                    </label>
                    <input
                      id='multi_purpose_type'
                      name='multi_purpose_type'
                      className='form-control'
                      value={MPTMasterData.multi_purpose_type}
                      onChange={onChangeHandle1}
                    />
                  </div>

                  <div className='form-group mb-3'>
                    <label
                      htmlFor='multi_purpose_remark'
                      className='form-label'
                    >
                      Remark
                    </label>
                    <input
                      id='multi_purpose_remark'
                      name='multi_purpose_remark'
                      className='form-control'
                      value={MPTMasterData.multi_purpose_remark}
                      onChange={onChangeHandle1}
                    />
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className='modal-footer'>
                <button
                  className='btn btn-primary'
                  onClick={MPTMaster_Add_Edit_Screen}
                >
                  Submit
                </button>
                <button className='btn btn-secondary' onClick={toggle}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Leadhistory;
